import { Directive, ElementRef, inject, input, OnInit } from '@angular/core';

@Directive({
  selector: '[iriroSetFocus]',
  standalone: true,
})
export class SetFocusDirective implements OnInit {
  iriroSetFocus = input.required<boolean | null>();

  el = inject(ElementRef);

  ngOnInit(): void {
    if(this.iriroSetFocus()) {
      this.el.nativeElement.focus();
    }
  }
}
